import { connect } from 'react-redux';
import { selectors } from '../Stream';
var mapStateToProps = function (state) { return ({
    biTotalItemsCount: selectors.getTotalItemsCount(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=BackToTop.container.js.map